import { COLOR, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { Z_INDEX } from "~/styles/z-index";

export const DivContainer = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 48px;
  left: 0px;
  width: 100%;
  height: calc(100vh - 32px);
  height: calc((var(--1dvh, 1vh) * 100));
  height: calc(100dvh - 32px);
  padding-bottom: 16px;
  background-color: ${COLOR.GRAY100.code};
  overflow-y: auto;
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  opacity: ${({ isVisible }) => (isVisible ? "1" : "0")};
  z-index: ${Z_INDEX.HEADER};

  ${mq.sp} {
    top: 45px;
  }
`;
